export const incomeJsonData = {
  "form21": [{
      label: "1）公司名稱 <br> Name of the Company*",
      key: "field21_1",
      leftSpan: 8,
      midSpan: 0,
      needUnit: false,
      type: "input",
      rightSpan: 16,
      isMoney: false,
    },
    {
      label: "2）辦公室地址<br>Address of the Company * ",
      key: "field21_2",
      leftSpan: 8,
      rightSpan: 16,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: false
    },

    {
      label: " 3） 辦公室電話 <br>Telephone No *",
      key: "field21_3",
      leftSpan: 8,
      rightSpan: 16,
      midSpan: 0,
      needUnit: false,
      needNumber: true,
      type: "input",
      isMoney: false
    },

    {
      label: "4）受僱日期<br>Employment Date*",
      key: "field21_4",
      leftSpan: 8,
      rightSpan: 16,
      midSpan: 0,
      needUnit: false,
      type: "date",
      isMoney: false
    },


    {
      label: "5）職位<br>Present Post*",
      key: "field21_5",
      leftSpan: 8,
      rightSpan: 16,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: false
    },


    {
      label: " (A) 現職最近 3 個曆月(若不足 3 個曆月，請由受僱日期起申報)之每月平均底薪<br>Average monthly basic income for the last 3 months (if less than 3 months, please count from the date of employment) *",
      key: "field21_A",
      leftSpan: 18,
      rightSpan: 6,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: true
    },


    {
      label: " (B) 現職最近 3 個曆月(若不足 3 個曆月，請由受僱日期起申報)之每月平均生活津貼<br>Average monthly allowance for the last 3 months (if less than 3 months, please count from the date of commencement) *",
      key: "field21_B",
      leftSpan: 18,
      rightSpan: 6,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: true
    },


    {
      label: " (C) 現職最近 3 個曆月(若不足 3 個曆月，請由受僱日期起申報)之每月平均逾時工作收入<br>Average monthly overtime earnings for the last 3 months (if less than 3 months, please count from the date of employment) *",
      key: "field21_C",
      leftSpan: 18,
      rightSpan: 6,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: true
    },


    {
      label: " (D) 現職最近 3 個曆月(若不足 3 個曆月，請由受僱日期起申報)之每月平均花紅/佣金(非年終的花紅或佣金)<br>Average monthly non-annual bonus / commission for the last 3 months (if less than 3 months, please count from the date of commencement) *",
      key: "field21_D",
      leftSpan: 18,
      rightSpan: 6,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: true
    },


    {
      label: " (E) 現職最近 3 個曆月(若不足 3 個曆月，請由受僱日期起申報)之每月平均其他津貼/獎金 (例如：交通費津貼/厭惡性工作津貼/勤工獎等)<br>Average monthly allowances for transportation / disgusting work / good attendance bonus etc. in the last 3 months (if less than 3 months, please count from the date of employment) *",
      key: "field21_E",
      leftSpan: 18,
      rightSpan: 6,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: true
    },


    {
      label: " (F) 現職最近 3 個曆月(若不足 3 個月，請由受僱日期起申報)之每月強積金/認可職業退休計劃供款 (請填報強積金或 認可職業退休計劃的強制性供款，請不要包括屬自願性質 的供款)<br>Monthly contributions to MPF/recognized Occupational Retirement Schemes for the last 3 months (if less than 3 months, please count from the date of employment) (please fill in the mandatory MPF/recognized occupational retirement scheme contributions, please do not include voluntary contributions) *",
      key: "field21_F",
      leftSpan: 18,
      rightSpan: 6,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: true
    },

    {
      label: "6）每月平均淨收入 (系統自動計算：A+B+C+D+E-F)  <br>    Average Monthly Net Income (A+B+C+D+E-F) *",
      key: "field21_6",
      leftSpan: 12,
      rightSpan: 12,
      midSpan: 0,
      readOnly: true,
      needUnit: false,
      type: "input",
      isMoney: true
    },
    {
      label: " 7）在過去一年度享有的年終雙薪/年終花紅/其他年終酬金之每月平均金額 (如適用)<br> Average monthly amount of year-end double salary / year-end bonus / other year-end remuneration (if applicable) *",
      key: "field21_7",
      leftSpan: 18,
      rightSpan: 6,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: true
    },
    {
      label: "8）資料或文件描述補充 (如有) <br> Add information and File Description (if any)",
      key: "field21_8",
      leftSpan: 8,
      rightSpan: 16,
      midSpan: 0,
      needUnit: false,
      type: "input",

      isMoney: false
    },
    {
      label: "",
      key: "uploadFiles",
      fileLabel: "有固定僱主人士",
      type: "upload",
      uploadDesc: "須遞交由公司發出的最近 3 個月糧單或薪金證明文件或稅單<br>Please provide for the last 3 months proof of salary advice, tax return or any other relevant / valid supporting document"
    }
  ],
  "form22": [{
      label: "1）現在的行業/職業<br>Current occupation & trade*",
      key: "field22_1",
      leftSpan: 7,
      midSpan: 0,
      needUnit: false,
      type: "input",
      rightSpan: 17,
      isMoney: false
    },
    {
      label: "2）在申請日前連續在職工作時間(最長計算期為 12 個曆月， 最短 3 個曆月)<br>Consecutive working period immediately before application date (longest for 12 calendar months, shortest for 3 calendar months) *",
      key: "field22_2",
      leftSpan: 18,
      rightSpan: 6,
      midSpan: 0,
      needUnit: true,
      needNumber: true,
      unit: "月",
      type: "input",
      rightSpan: 6,
      isMoney: false
    },
    {
      label: "3）在過去 12 個曆月或相應月數，每月平均收入<br>Average monthly income in the last 12 calendar months or the corresponding working months*",
      key: "field22_3",
      leftSpan: 18,
      midSpan: 0,
      needUnit: false,
      type: "input",
      rightSpan: 6,
      isMoney: true
    },
    {
      label: "4）資料或文件描述補充 (如有)<br>Add information and File Description (if any)",
      key: "field22_4",
      leftSpan: 10,
      midSpan: 0,
      needUnit: false,
      type: "input",
      rightSpan: 14,
      isMoney: false,
    },
    {
      label: "",
      key: "uploadFiles",
      fileLabel: "沒有固定僱主人士",
      type: "upload",
      uploadDesc: "須附上有關證明，如存摺記錄或支薪記錄等<br> Please provide with valid supporting document such as passbook / salary record"
    }
  ],
  "form23": [{
      label: "1）公司名稱 <br> Name of the Company*",
      key: "field23_1",
      leftSpan: 8,
      midSpan: 0,
      needUnit: false,
      type: "input",
      rightSpan: 16,
      isMoney: false
    },
    {
      label: "2）公司地址<br>  Company Address*",
      key: "field23_2",
      leftSpan: 8,
      rightSpan: 16,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: false
    },
    {
      label: "3）公司電話<br>Company Phone Number*",
      key: "field23_3",
      leftSpan: 8,
      rightSpan: 16,
      midSpan: 0,
      needUnit: false,
      needNumber: true,
      type: "input",
      isMoney: false
    },
    {
      label: "4）該公司是獨資 / 合股經營<br>Sole proprietor / co-owners*",
      key: "field23_4",
      leftSpan: 8,
      rightSpan: 16,
      midSpan: 0,
      needUnit: false,
      type: "select",
      isMoney: false,
      options: "company_property"
    },
    {
      label: "5）本人佔公司股份百分比<br>Percentage of shares owned by me*",
      key: "field23_5",
      leftSpan: 8,
      rightSpan: 16,
      midSpan: 0,
      needUnit: false,
      needNumber: true,
      type: "input",
      isMoney: false
    },
    {
      label: "6）其他合股人估公司股份百分比<br>Percentage of shares held by other partners*",
      key: "field23_6",
      leftSpan: 18,
      rightSpan: 6,
      midSpan: 0,
      needUnit: true,
      needNumber: true,
      unit: "%",
      type: "input",
      isMoney: false
    },
    {
      label: "(A)公司在填報日前的連續營業暦月(如已連續營業12個暦月以上，請填寫12,最短為3個曆月)<br>The company's consecutive business operation period immediately before application date(please state 12 even if more than 12 months, 3 months is the shortest)*",
      key: "field23_A",
      leftSpan: 18,
      rightSpan: 6,
      midSpan: 0,
      needUnit: true,
      needNumber: true,
      unit: "月",
      type: "input",
      isMoney: false
    },


    {
      label: "(B)公司在上述連續營業曆月的總營業額<br>Total turnover of the company in the above consecutive business calendar months*",
      key: "field23_B",
      leftSpan: 18,
      rightSpan: 6,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: true
    },


    {
      label: "(C)公司在上述連續營業曆月的總營支出<br>Total expenditure of the company in the above consecutive business calendar months*",
      key: "field23_C",
      leftSpan: 18,
      rightSpan: 6,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: true
    },


    {
      label: "(D)公司在上述連續營業曆月的利潤 / 虧損總值(B)-(C)<br>Total proft/loss of the company in the above consecutive business calendar months (B)-(C) *",
      key: "field23_D",
      leftSpan: 18,
      rightSpan: 6,
      midSpan: 0,
      needUnit: false,
      readOnly: true,
      type: "input",
      isMoney: true
    },


    {
      label: "(E)公司每月平均淨利潤 / 虧損(D) ÷ (A)<br>Average monthly net proft/loss of the company (D) ÷ (A) *",
      key: "field23_E",
      leftSpan: 18,
      rightSpan: 6,
      midSpan: 0,
      needUnit: false,
      readOnly: true,
      type: "input",
      isMoney: true
    },


    {
      label: "(F)支取每月平均薪金<br>Average monthly salary received *",
      key: "field23_F",
      leftSpan: 18,
      rightSpan: 6,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: true
    },

    {
      label: "7）資料或文件描述補充 (如有) <br> Add information and File Description (if any)",
      key: "field23_7",
      leftSpan: 8,
      rightSpan: 16,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: false
    },
    {
      label: "",
      key: "uploadFiles",
      fileLabel: "持有商業登記的自僱人士",
      type: "upload",
      uploadDesc: "須遞交商業登記副本、股權登記<br>Please provide a copy of the business registration certificate and share register”",
    }
  ],
  "form24": [{
      label: "1）現在的行業/職業  <br> Current occupation & trade*",
      key: "field24_1",
      leftSpan: 8,
      rightSpan: 16,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: false
    },
    {
      label: "2）在申請日前，公司連續經營時間(如已連續經營 12 個曆月以上，請填寫 12，最短為 3 個曆月)<br>The company's consecutive business operation period immediately before application date (please  state 12 even if more than 12 months, the shortest is 3 months) *",
      key: "field24_2",
      leftSpan: 18,
      rightSpan: 6,
      midSpan: 0,
      needUnit: true,
      needNumber: true,
      unit: "月",
      type: "input",
      isMoney: false
    },
    {
      label: "3）公司資產淨值為港幣(根據公司最近期營業損益表計算)<br>Net asset value of the company (based on the most updated financial report) *",
      key: "field24_3",
      leftSpan: 16,
      rightSpan: 8,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: true
    },
    {
      label: "4）過去 12 個曆月或相應月數，每月平均盈利 / 虧損<br>Average monthly profit / loss in the past 12 calendar months or the corresponding operating months*",
      key: "field24_4",
      leftSpan: 16,
      rightSpan: 8,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: true
    },
    {
      label: "5）資料或文件描述補充 (如有) <br> Add information and File Description (if any)",
      key: "field24_5",
      leftSpan: 8,
      rightSpan: 16,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: false
    },
    {
      label: "",
      key: "uploadFiles",
      fileLabel: "沒有商業登記自僱人士",
      type: "upload",
      uploadDesc: "須遞交收入證明文件<br>Please provide proof of income",
    }
  ],
  "form25": [{
      label: "1）在申請日前租用車輛營運期(最長為 12 個曆月，最短為 3 個曆月)<br>The consecutive operation period immediately before the application date (longest for 12 calendar months & shortest for 3 months)*",
      key: "field25_1",
      leftSpan: 18,
      rightSpan: 6,
      midSpan: 0,
      needUnit: true,
      needNumber: true,
      unit: "月",
      type: "input",
      isMoney: false
    },
    {
      label: "2）租用的士/小巴自行營業的公司名稱<br>Car hiring company*",
      key: "field25_2",
      leftSpan: 8,
      rightSpan: 16,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: false
    },
    {
      label: "3）在過去 12 個曆月或相應經營月數，每月平均收入 (營業收入總額扣除營業開支總額，包括車租、油費、泊車等 ÷ 相應月數）<br>The average monthly income for the past 12 calendar months or the corresponding period (Deducting the total operating expenses including car rental, fuel costs, parking, etc. from total income and to divide by the corresponding operation months) *",
      key: "field25_3",
      leftSpan: 18,
      rightSpan: 6,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: true
    }
  ],
  "form26": [{
      label: "1）車輛登記編號 <br>The registration number of my owned taxi/public light bus*",
      key: "field26_1",
      leftSpan: 12,
      rightSpan: 12,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: false
    },
    {
      label: "2）在申請前 12 個曆月，每月平均收取車租 <br> Average monthly rent received from the vehicle in the past 12 calendar months*",
      key: "field26_2",
      leftSpan: 18,
      rightSpan: 6,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: true
    },
    {
      label: "3）在申請前 12 個曆月，每月平均自我經營該車輛收入<br>Average monthly income from self-operating the vehicle in the past 12 calendar months*",
      key: "field26_3",
      leftSpan: 18,
      rightSpan: 6,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: true
    },
    {
      label: "4）在申請前 12 個曆月每月平均支出，包括但不限於車輛供款、保險、商業登記、維修費、泊車費、燃油 成本、折舊<br>Average monthly expenditure of the vehicle in the past 12 calendar months. Expenditures include but not limited to hire purchase payment, insurance, business registration, maintenance fee, parking fee, fuel cost, depreciation*",
      key: "field26_4",
      leftSpan: 18,
      rightSpan: 6,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: true
    },
    {
      label: "5）每月平均淨收入<br>Average monthly net proft / loss*",
      key: "field26_5",
      leftSpan: 18,
      rightSpan: 6,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: true
    },
    {
      label: "6）資料或文件描述補充 (如有) <br> Add information and File Description (if any)",
      key: "field26_6",
      leftSpan: 8,
      rightSpan: 16,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: false
    },
    {
      label: "",
      key: "uploadFiles",
      fileLabel: "擁有的士/公共小型巴士/自行營業的自僱人士",
      type: "upload",
      uploadDesc: "須遞交牌照、商用車輛分期付款合約及商用車輛牌照的最近期估值報<br>Please provide the copy of commercial vehicle (taxi/public light bus) licence, hire Purchase Agreement and valuation report for commercial vehicle license",
    }
  ],
  "form27": [{
      label: "1）我每月領取 *贍養費 / 子女管養費 (如有) <br> The monthly alimony I received for myself / my children (if any)",
      key: "field27_1",
      midKey: "hadChildrenRec",
      midType: "select",
      midOptions: "alimony_type",
      leftSpan: 12,
      rightSpan: 6,
      midSpan: 6,
      needUnit: false,
      type: "input",
      isMoney: true
    },
    {
      label: "2）我每月支付 *贍養費 / 子女管養費 (如有)<br>The monthly alimony I am paying to my ex-spouse / children (if any)",
      key: "field27_2",
      midKey: "hadChildrenPay",
      midType: "select",
      midOptions: "alimony_type",
      leftSpan: 12,
      rightSpan: 6,
      midSpan: 6,
      needUnit: false,
      type: "input",
      isMoney: true
    },
    {
      label: "3）資料或文件描述補充 (如有) <br> Add information and File Description (if any)",
      key: "field27_3",
      leftSpan: 8,
      rightSpan: 16,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: false
    },
    {
      label: "",
      key: "uploadFiles",
      fileLabel: "領取/支付贍養費的離婚人士",
      type: "upload",
      uploadDesc: "須上傳法庭判令副本<br>Please provide the copy of court order",
    }
  ]
}



// WEBPACK FOOTER //
// ./src/utils/json/incomeFormField.js